export interface PaginatedResponse<T> {
  items: T[];
  total: number;
  page: number;
  pages: number;
}

export interface BaseFilters {
  page: number;
  per_page: number;
}

export enum Status {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  SUCCESS = 'SUCCESS',
  APPEAL = 'APPEAL',
  NOT_FOUND = 'NOT_FOUND',
}

export interface AuthResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
} 